import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      &::-webkit-outer-spin-button,\n      &::-webkit-inner-spin-button {\n        margin: 0; /* apparently some margin are still there even though it's hidden */\n        /* stylelint-disable-next-line property-no-vendor-prefix */\n        -webkit-appearance: none; /* remove spinners on WebKit desktop browsers */\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      &::-webkit-date-and-time-value {\n        text-align: left;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      &::-webkit-search-decoration,\n      &::-webkit-search-cancel-button,\n      &::-webkit-search-results-button,\n      &::-webkit-search-results-decoration {\n        display: none;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
var Wrapper = /*#__PURE__*/ styled("div", {
    target: "e3xq1hc0"
})("position:relative;display:inline-block;width:100%;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.default;
}, ";text-align:left;");
var Label = /*#__PURE__*/ styled("label", {
    target: "e3xq1hc1"
})("position:absolute;top:-0.5625rem;left:0.75rem;clip:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "rect(0 0 0 0)" : "";
}, ";z-index:2;margin:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "-1px" : "";
}, ";padding:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "0" : "0 0.25rem";
}, ";width:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "1px" : "";
}, ";height:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "1px" : "";
}, ";color:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid, isDisabled = param.isDisabled;
    var color = theme.color.natural40;
    if (isDisabled) {
        color = theme.color.natural50;
    }
    if (isInvalid) {
        color = theme.color.error;
    }
    return color;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-size:0.75rem;line-height:1.5;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;opacity:", function(param) {
    var isFilled = param.isFilled;
    return isFilled ? "1" : "0";
}, ";transform:", function(param) {
    var isFilled = param.isFilled;
    return isFilled ? "translate3d(0, 0, 0)" : "translate3d(0, 0.375rem, 0)";
}, ";transition:transform 0.15s,opacity 0.1s,background-color 0.1s;pointer-events:none;");
var Input = /*#__PURE__*/ styled("input", {
    target: "e3xq1hc2"
})("display:", function(param) {
    var type = param.type;
    return type === "date" ? "inline-flex" : "inline-block";
}, ";margin:0;padding:", function(param) {
    var iconPosition = param.iconPosition, type = param.type;
    switch(iconPosition){
        case "left":
            if (type === "password") {
                return "0.625rem 2.85rem";
            }
            return "0.625rem 1rem 0.625rem 2.85rem";
        case "right":
            if (type === "password") {
                return "0.625rem 5.5rem 0.625rem 1rem";
            }
            return "0.625rem 2.85rem 0.625rem 1rem";
        default:
            if (type === "password") {
                return "0.625rem 2.85rem 0.625rem 1rem";
            }
            return "0.625rem 1rem";
    }
}, ";border:1px solid\n    ", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid;
    return isInvalid ? theme.color.error : theme.color.natural50;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.sm;
}, ";outline:0;width:100%;height:3.125rem;font-family:inherit;font-size:1rem;/* 16px size prevents focus zoom on iOS */\n  line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";background-clip:padding-box;/* removes inner shadow on iOS */\n  box-shadow:none;/* removes validation outlines in Firefox */\n  box-sizing:border-box;/* stylelint-disable-next-line property-no-vendor-prefix */\n  -moz-appearance:", function(param) {
    var type = param.type;
    return type === "number" && "textfield" /* remove spinners in Gecko browsers */ ;
}, ";appearance:", function(param) {
    var type = param.type;
    return type === "date" && "none" /* remove ugly iOS date input look */ ;
}, ";", function(p) {
    return (p.type === "number" || p.type === "date") && css(_templateObject());
}, " ", function(param) {
    var type = param.type;
    return type === "date" && css(_templateObject1());
}, " ", function(param) {
    var type = param.type;
    return type === "search" && css(_templateObject2());
}, "  &:hover,&:focus{border-color:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid;
    return isInvalid ? theme.color.error : theme.color.natural30;
}, ";}&::placeholder{color:", function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.color.secondary100 : theme.color.natural40;
}, ";opacity:1;}&::-ms-clear{display:none;}&[readonly],&[disabled]{border-color:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid;
    return isInvalid ? theme.color.error : theme.color.natural50;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";cursor:not-allowed;pointer-events:none;}& + svg{display:inline-flex;align-items:center;position:absolute;top:0.75rem;left:", function(param) {
    var iconPosition = param.iconPosition;
    return iconPosition === "left" ? "1rem" : "";
}, ";right:", function(param) {
    var iconPosition = param.iconPosition, type = param.type;
    if (iconPosition === "right") {
        if (type === "password") {
            return "3rem";
        }
        return "1rem";
    }
    return "";
}, ";width:1.6rem;height:1.6rem;fill:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid, isFilled = param.isFilled, isActive = param.isActive;
    var color = theme.color.natural50;
    if (isFilled || isActive) {
        color = theme.color.secondary100;
    }
    if (isInvalid) {
        color = theme.color.error;
    }
    return color;
}, ";}");
var ToggleButton = /*#__PURE__*/ styled("button", {
    target: "e3xq1hc3"
})("display:inline-flex;position:absolute;top:0.75rem;right:1rem;margin:0;padding:0;border:0;width:1.6rem;height:1.6rem;font:inherit;color:inherit;background:none;fill:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid;
    return isInvalid ? theme.color.error : theme.color.secondary100;
}, ";cursor:pointer;svg{width:100%;height:100%;}");
export { Wrapper, Label, Input, ToggleButton };
